import log from './log';
import GlobalVariables from '../GlobalVariables';
import { LogLevel } from '../enums/Enum';
import fromQueryString from './fromQueryString';

export const ensureTracking = () => {
    if (!GlobalVariables.Tracking && window.ApexChatAnalyticsID) {
        log('starting tracking...', LogLevel.Debug);
        if (ApexChat.gaDebug) {
            window.ga_debug = { trace: true };
        }

        if (!window.GoogleAnalyticsObject) {
            log('analytics loading...');
            (function (i, s, o, g, r, a, m) {
                i.GoogleAnalyticsObject = r;
                (i[r] =
                    i[r] ||
                    function () {
                        (i[r].q = i[r].q || []).push(arguments);
                    }),
                    (i[r].l = 1 * new Date());
                (a = s.createElement(o)), (m = s.getElementsByTagName(o)[0]);
                a.async = 1;
                a.src = g;
                m.parentNode.insertBefore(a, m);
            })(
                window,
                document,
                'script',
                `//www.google-analytics.com/analytics${ApexChat.gaDebug ? '_debug' : ''}.js`,
                '__apexGA'
            );
        } else {
            log('Analytics skipped, existing reference found...', LogLevel.Debug);
            window.__apexGA = window[window.GoogleAnalyticsObject];
        }

        __apexGA('create', window.ApexChatAnalyticsID, 'auto', {
            allowLinker: true,
            clientId: fromQueryString(ApexChat.gaClientId),
            cookieDomain: window.location.hostname == 'localhost' ? 'none' : 'auto',
            alwaysSendReferrer: true,
            sampleRate: 100, // all users get tracked for regular events
            siteSpeedSampleRate: window.location.hostname == 'localhost' ? 100 : 50, // half of all users get tracked for timing events
            name: 'apex'
        });
        log('tracking initialized', LogLevel.Debug);

        // on load, store the client id in a global param
        __apexGA((tracker) => {
            ApexChat.gaLinker = tracker.get('linkerParam');
            ApexChat.gaClientId = tracker.get('clientId');
        });

        GlobalVariables.Tracking = true;
    }
};
export default ensureTracking;
